import _classCallCheck from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
var Queue = /*#__PURE__*/function () {
  function Queue() {
    _classCallCheck(this, Queue);
    _defineProperty(this, "queue", []);
  }
  return _createClass(Queue, [{
    key: "isQueueEmpty",
    get: function get() {
      return this.queue.length === 0;
    }
  }, {
    key: "show",
    value: function show() {
      this.queue.push(1);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.queue.pop();
    }
  }, {
    key: "clearQueue",
    value: function clearQueue() {
      for (var i = 0; i < this.queue.length; i++) {
        this.hide();
      }
    }
  }]);
}();
export { Queue as default };